module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/specific_websites-d98ff3b8f743d129853537e6056cc16e.svg";